<h1 mat-dialog-title>Link request</h1>

<div mat-dialog-content class="rnr">
    <div class="rnr__author" data-test="link-request">
        <mat-icon>handshake</mat-icon>
        <div>
            <div class="rnr__author-name">{{ data.title }}</div>
            <div class="hint">Only you, as the practice owner, can answer.</div>
        </div>
    </div>
    <p class="hint">Once linked, either practice can refer patients to the other within MedicAI, and each shares only
        the records it chooses. Nothing is shared by accepting. You can end the link at any time in
        Settings › MedicAI Network.</p>
    <div class="rnr__alert" *ngIf="actionError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ actionError }}</div>
    </div>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Later</button>
    <button mat-stroked-button (click)="answer('decline')" [disabled]="isSaving" data-test="decline-link">Decline</button>
    <button mat-flat-button color="primary" (click)="answer('accept')" [disabled]="isSaving" data-test="accept-link">
        {{ isSaving ? 'Saving…' : 'Accept' }}
    </button>
</div>
